const Button = theme => {
  return {
    MuiButton: {
      defaultProps: {
        size: 'medium'
      },
      variants: [{
        props: {
          size: 'medium'
        },
        style: {
          height: 36
        }
      }, {
        props: {
          size: 'small'
        },
        style: {
          height: 30
        }
      }, {
        props: {
          size: 'large'
        },
        style: {
          height: 42
        }
      }, {
        props: {
          variant: 'contained',
          color: 'error'
        },
        style: {
          backgroundColor: theme.palette.error.main,
          border: '1px solid',
          borderColor: theme.palette.error.dark,
          '&:hover': {
            backgroundColor: '#ab2f26'
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'overlay'
        },
        style: {
          color: theme.palette.secondary.dark,
          border: '1px solid',
          borderColor: theme.palette.secondary.contrastText,
          '&:hover': {
            borderColor: theme.palette.secondary.contrastText
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'overlay'
        },
        style: {
          color: theme.palette.secondary.contrastText,
          border: '1px solid',
          borderColor: theme.palette.secondary.contrastText,
          '&:hover': {
            borderColor: theme.palette.secondary.contrastText
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'secondary'
        },
        style: {
          color: '#1A1C18',
          border: '1px solid',
          borderColor: '#1A1C18',
          '&:hover': {
            borderColor: '#252822',
            backgroundColor: '#0000000A'
          }
        }
      }, {
        props: {
          variant: 'text',
          color: 'secondary'
        },
        style: {
          color: '#1A1C18',
          '&:hover': {
            backgroundColor: '#00000005'
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'warning'
        },
        style: {
          backgroundColor: theme.palette.warning.main,
          border: '1px solid',
          borderColor: theme.palette.warning.dark,
          '&:hover': {
            backgroundColor: '#ab2f26'
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'success'
        },
        style: {
          backgroundColor: theme.palette.success.main,
          border: '1px solid',
          borderColor: theme.palette.success.dark,
          '&:hover': {
            backgroundColor: '#2a8f58'
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'info'
        },
        style: {
          backgroundColor: theme.palette.info.main,
          border: '1px solid',
          borderColor: theme.palette.info.dark,
          '&:hover': {
            backgroundColor: '#4a4300'
          }
        }
      }, {
        props: {
          variant: 'contained',
          disabled: true
        },
        style: {
          backgroundColor: theme.palette.info.main,
          border: '1px solid',
          borderColor: theme.palette.action.disabledBackground,
          '&:hover': {
            backgroundColor: '#4a4300'
          }
        }
      }],
      styleOverrides: {
        root: {
          fontWeight: theme.typography.fontWeightMedium,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        },
        containedInherit: {
          border: 'none'
        },
        disabled: {
          backgroundColor: 'red'
        },
        containedPrimary: {
          backgroundColor: theme.palette.primary.light,
          border: `1px solid ${theme.palette.primary.main}`,
          '&:hover': {
            backgroundColor: '#8ea93a'
          }
        },
        containedSecondary: {
          backgroundColor: '#1A1C18',
          border: `1px solid #444840`,
          '&:hover': {
            backgroundColor: '#252822'
          },
          '&:active': {
            backgroundColor: '#252822'
          },
          '&:focus': {
            backgroundColor: '#252822'
          },
          '&:selected': {
            backgroundColor: '#252822'
          },
          '&:disabled': {
            backgroundColor: '#25282242',
            color: '#fff'
          },
          '.MuiLoadingButton-loadingIndicator': {
            color: '#fff'
          }
        }
      }
    }
  };
};

export { Button };
